export enum Searchable {
    SERIAL_NUMBER = 0,
    CONNECTION_ID = 1,
    PATIENT_NAME = 2,
    PATIENT_ID = 3,
    USERNAME = 4,
    EMAIL = 5
}
